import React, { useState } from 'react'

import { useNavigate } from 'react-router-dom'

import UIButton from '../../components/UI/UIButton'
import { Icon } from '../../components/Icon'
import { ReactComponent as LogoSvg } from '../../assets/svgs/logos/Logo.svg'
import UISwitch from '../../components/UI/UISwitch'

const ChooseInstitute = () => {
  const navigate = useNavigate()
  const [switchValue, setSwitchValue] = useState<boolean>(false)

  const handleSwitchChange = (value: boolean) => {
    setSwitchValue(value)
  }

  return (
    <div className="min-h-screen bg-gray1 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="mx-5 sm:mx-auto sm:w-full sm:max-w-lg flex">
        <div className="flex gap-4 flex-1 ">
          <LogoSvg width={130} height={36} />
        </div>
        <div className="">
          <div className="bg-gray2 py-3 px-4 rounded-3xl cursor-pointer flex gap-2 items-center">
            <Icon
              name="IconMessageAlertSquare"
              width={16}
              height={16}
              strokeWidth={1}
              stroke={'#02698C'}
            />
            <p className="text-xs font-medium text-text3">Whistleblowing</p>
            <Icon
              name="IconArrowRight"
              width={16}
              height={16}
              strokeWidth={1}
              stroke={'#02698C'}
            />
          </div>
        </div>
      </div>

      <div className="mx-5 sm:mx-auto mt-8 sm:w-full sm:max-w-lg">
        <div className="bg-white py-10 px-4 shadow rounded-[1rem] sm:px-10">
          <div onClick={() => navigate(-1)} className="cursor-pointer w-fit">
            <Icon
              name={'IconArrowNarrowLeft'}
              width={24}
              height={24}
              strokeWidth={1.5}
              stroke={'#02698C'}
            />
          </div>
          <div className="flex flex-col py-2 gap-3 justify-center items-center text-center mt-7">
            <Icon
              name="IconBuilding"
              width={52}
              height={52}
              strokeWidth={1}
              stroke={'#02698C'}
            />
            <p className="text-lg font-bold text-text2">
              Great stuff, choose your data
            </p>
            <p className="text-sm font-normal text-text1">
              Please specify which data you want to be visible inside the SCR
              platform. You can always update this later in your settings.
            </p>
          </div>
          <div className="mt-8">
            <div className="flex flex-col gap-5">
              <div className="rounded-xl bg-gray1 p-4 flex gap-3">
                <div>
                  <img
                    src="/squircle.png"
                    width={32}
                    height={32}
                    className="rounded-lg"
                  />
                </div>
                <div className="flex flex-col flex-1 gap-1 mt-1">
                  <p className="font-semibold text-sm leading-6 text-text4">
                    School Name 1
                  </p>
                  <div className="flex gap-2 items-center">
                    <Icon
                      name="IconMarkerPin"
                      width={12}
                      height={12}
                      strokeWidth={1}
                      stroke={'#3487A2'}
                    />
                    <p className="font-medium text-xs leading-5 text-text1">
                      Bowes Rd, Arnos Grove, London N11 2HL
                    </p>
                  </div>
                </div>
                <div>
                  <UISwitch
                    value={switchValue}
                    onValueChange={handleSwitchChange}
                  />
                </div>
              </div>
              <div className="rounded-xl bg-gray1 p-4 flex gap-3">
                <div>
                  <img
                    src="/squircle2.png"
                    width={32}
                    height={32}
                    className="rounded-lg"
                  />
                </div>
                <div className="flex flex-col flex-1 gap-1 mt-1">
                  <p className="font-semibold text-sm leading-6 text-text4">
                    School Name 2
                  </p>
                  <div className="flex gap-2 items-center">
                    <Icon
                      name="IconMarkerPin"
                      width={12}
                      height={12}
                      strokeWidth={1}
                      stroke={'#3487A2'}
                    />
                    <p className="font-medium text-xs leading-5 text-text1">
                      Bowes Rd, Arnos Grove, London N11 2HL
                    </p>
                  </div>
                </div>
                <div>
                  <UISwitch
                    value={switchValue}
                    onValueChange={handleSwitchChange}
                  />
                </div>
              </div>
              <div className="rounded-xl bg-gray1 p-4 flex gap-3">
                <div>
                  <img
                    src="/squircle3.png"
                    width={32}
                    height={32}
                    className="rounded-lg"
                  />
                </div>
                <div className="flex flex-col flex-1 gap-1  mt-1">
                  <p className="font-semibold text-sm leading-6 text-text4">
                    School Name 3
                  </p>
                  <div className="flex gap-2 items-center">
                    <Icon
                      name="IconMarkerPin"
                      width={12}
                      height={12}
                      strokeWidth={1}
                      stroke={'#3487A2'}
                    />
                    <p className="font-medium text-xs leading-5 text-text1">
                      Bowes Rd, Arnos Grove, London N11 2HL
                    </p>
                  </div>
                </div>
                <div>
                  <UISwitch
                    value={switchValue}
                    onValueChange={handleSwitchChange}
                  />
                </div>
              </div>

              <div className="container mx-auto mt-3">
                <UIButton
                  label="Select"
                  type="button"
                  onClick={() => console.log('Select')}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="sm:mx-auto w-full h-auto px-8 my-4 py-6 rounded-[1rem] gap-16 bg-gray2">
          <div className="flex gap-3 items-center">
            <Icon
              name={'IconCheckMonogram'}
              width={16}
              height={16}
              strokeWidth={1}
            />
            <p className="font-medium text-xs leading-5 text-text1">
              Privacy Policy
            </p>
            <p className="font-medium text-xs leading-5 text-text1">
              Terms & Conditions
            </p>
          </div>
          <div className="mt-4">
            <p className="font-medium text-xs leading-5 text-text3">
              All rights reserved. SCR Solutions is a trading name of
              Streamlearn Ltd. Company No. 12180453. Registered office: Axis 19
              Mallard Way, Riverside Business Park, Swansea Vale, Swansea, SA7
              0AJ.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChooseInstitute
